import { FC, ReactNode } from "react";
import { Flex, Text } from "@chakra-ui/react";

import { CASE_FILE_STATUS, CaseDocumentFileModel } from "@shared/models";
import { pluralize } from "@containers/Cases/utils/caseDocuments";

import CaseDocumentFileTag from "../CaseDocumentFileTag";
import { formatFileSize } from "../CaseDocuments.utils";

interface CaseDocumentFileRowProps {
  file: CaseDocumentFileModel;
  /** Shown at the end of the row */
  children: ReactNode;
}

const CaseDocumentFileRow: FC<CaseDocumentFileRowProps> = ({ file, children }) => {
  const { name, size, pages, status, error_message } = file;
  const isFailed = status === CASE_FILE_STATUS.FAILED;
  const meta = [size !== null && formatFileSize(size), pages !== null && pluralize(pages, "page")]
    .filter(Boolean)
    .join(" · ");

  return (
    <Flex align="center" gap={3} px="14px" py="11px" borderRadius="8px" border="1px solid" borderColor="gray.200">
      <CaseDocumentFileTag file={file} />
      <Flex direction="column" gap="2px" flex={1} minW={0}>
        <Text truncate fontSize="14px" color="brand.modalHeaderText">
          {name}
        </Text>
        {isFailed ? (
          <Text fontSize="12px" color="score.lowText">
            {error_message || "Couldn't read this file."}
          </Text>
        ) : (
          meta && (
            <Text fontSize="12px" color="brand.emptyStateText">
              {meta}
            </Text>
          )
        )}
      </Flex>
      {children}
    </Flex>
  );
};

export default CaseDocumentFileRow;
